import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";

const CustomerInteraction = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="Customer Interaction Standards" 
        description="Building lasting relationships with our customers"
      >
        <section className="space-y-6">
          <p>
            Positive customer interactions are the foundation of our business. Every conversation 
            is an opportunity to build trust, demonstrate expertise, and create a loyal advocate 
            for BlueLux.
          </p>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">First Impressions Matter</h2>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Introduce yourself by name on first meeting</li>
            <li>Make eye contact and offer a friendly greeting</li>
            <li>Dress in clean, professional uniform</li>
            <li>Project confidence and competence</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Communication Best Practices</h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-medium">Be Proactive</h3>
              <p className="text-muted-foreground">
                Don't wait for customers to ask—provide updates about pool condition, upcoming needs, 
                and seasonal recommendations.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium">Explain in Simple Terms</h3>
              <p className="text-muted-foreground">
                Avoid technical jargon. Help customers understand what you're doing and why it matters.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium">Listen Actively</h3>
              <p className="text-muted-foreground">
                Pay attention to customer concerns and preferences. Make notes in their account.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-medium">Set Expectations</h3>
              <p className="text-muted-foreground">
                Be clear about timelines, costs, and what customers can expect from services.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Handling Difficult Situations</h2>
          <p>When customers are upset or dissatisfied:</p>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Listen without interrupting—let them express concerns fully</li>
            <li>Acknowledge their feelings: "I understand why that's frustrating"</li>
            <li>Take ownership: "Let me make this right"</li>
            <li>Propose solutions or escalate to management</li>
            <li>Follow up to ensure resolution</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Boundaries and Professionalism</h2>
          <p>Maintain professional boundaries:</p>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>All communication should be service-related</li>
            <li>Avoid controversial topics (politics, religion, etc.)</li>
            <li>Decline invitations to social events with customers</li>
            <li>Report any inappropriate customer behavior to management</li>
          </ul>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default CustomerInteraction;